module.exports = __webpack_public_path__ + "img/avo.bfa2fd93.png";